import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const projects = [
  {
    id: "missoes-caatinga",
    title: "Missões Caatinga",
    description:
      "Viagens missionárias periódicas ao sertão nordestino, levando o evangelho, apoio humanitário e acompanhamento contínuo das comunidades.",
    highlight: "Missões",
    link: "/missoes-caatinga",
  },
  {
    id: "teologia",
    title: "Curso de Teologia",
    description:
      "Formação teológica sólida, centrada nas Escrituras, para capacitar servos e líderes vocacionados para a obra do Senhor.",
    highlight: "Formação",
    link: "/teologia",
  },
  {
    id: "projetos-sociais",
    title: "Projetos Sociais",
    description:
      "Ações contínuas de cuidado integral: cestas básicas, acompanhamento de famílias, apoio a crianças e idosos vulneráveis.",
    highlight: "Ação Social",
    link: "/missao",
  },
];

const HomeProjects = () => {
  return (
    <section className="section-shell">
      <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="section-title">Nossos Projetos</p>
          <h2 className="section-heading">Evangelho em movimento.</h2>
          <p className="section-subtitle">
            Conheça as frentes que o Instituto desenvolve para plantar o evangelho e regar esperança em diferentes
            contextos.
          </p>
        </div>
        <Button variant="outline" className="btn-pill-lg border-primary/40 text-primary hover:bg-primary/5">
          Ver missão completa
        </Button>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {projects.map((project) => (
          <article
            key={project.id}
            className="card-ambient hover-lift flex flex-col justify-between p-6 animate-fade-in"
          >
            <div className="space-y-3">
              <span className="inline-flex rounded-full bg-secondary/10 px-3 py-1 text-xs font-semibold text-secondary">
                {project.highlight}
              </span>
              <h3 className="text-xl font-semibold text-foreground">{project.title}</h3>
              <p className="text-sm text-muted-foreground">{project.description}</p>
            </div>
            <div className="mt-6 flex items-center justify-between">
              <Button variant="ghost" className="px-0 text-sm font-semibold text-primary hover:bg-primary/5" asChild>
                <a href={project.link}>
                  Conhecer mais
                  <ArrowRight className="ml-1 h-4 w-4" />
                </a>
              </Button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default HomeProjects;
